<h1 class="title">Tu y es presque ! ✨</h1>
<div class="content">
  <div class="image">
    <img [src]="`assets/mail.jpg`">
  </div>
  <div class="form">
    <p class="info">
      Saisis tes informations pour découvrir tes résultats et accéder à ton profil complet.
    </p>
    <form [formGroup]="formGroup" class="flex flex-column w-full gap-4">
      <div class="form-item flex flex-column gap-1">
        <p-floatlabel variant="on">
          <input id="firstName" type="text" pInputText [fluid]="true" [formControl]="formGroup.controls.firstName"
                 autocomplete="off"
                 [invalid]="isInvalid(formGroup.controls.firstName)"/>
          <label for="firstName">Prénom*</label>
        </p-floatlabel>
        @if (isInvalid(formGroup.controls.firstName)) {
          <p-message severity="error" size="small" variant="simple">Le prénom est requis.</p-message>
        }

      </div>
      <div class="form-item flex flex-column gap-1">
        <p-floatlabel variant="on">
          <input id="lastName" type="text" pInputText [fluid]="true" [formControl]="formGroup.controls.lastName"
                 autocomplete="off"
                 [invalid]="isInvalid(formGroup.controls.lastName)"/>
          <label for="lastName">Nom*</label>
        </p-floatlabel>
        @if (isInvalid(formGroup.controls.lastName)) {
          <p-message severity="error" size="small" variant="simple">Le nom de famille est requis.</p-message>
        }
      </div>
      <div class="form-item flex flex-column gap-1">
        <p-floatlabel variant="on">
          <input id="email" type="text" pInputText [fluid]="true" [formControl]="formGroup.controls.email"
                 autocomplete="off"
                 [invalid]="isInvalid(formGroup.controls.email)"/>
          <label for="email">Email*</label>
        </p-floatlabel>
        @if (isInvalid(formGroup.controls.email)) {
          @if (formGroup.controls.email.errors?.['required']) {
            <p-message severity="error" size="small" variant="simple">Votre email est requis.</p-message>
          }
          @if (formGroup.controls.email.errors?.['pattern']) {
            <p-message severity="error" size="small" variant="simple">Veuillez entrer une adresse email valide.
            </p-message>
          }
        }
      </div>
      <div class="form-item flex flex-row gap-1 justify-content-center align-items-center">
        <p-checkbox name="consent" [binary]="true" [inputId]="'consent'"
                    [invalid]="isInvalid(formGroup.controls.consent)"
                    [formControl]="formGroup.controls.consent"/>
        <label for="consent" class="ml-2"> J'accepte que mon adresse mail soit utilisée par Lumenité Étoilée pour
          m'envoyer des actualités et que mon profil soit analysé pour l'amélioration des futurs événements.*</label>
      </div>
    </form>
    <div class="action">
      <p-button [disabled]="!isValid()" label="Valider" icon="pi pi-check" [loading]="loading()"
                (onClick)="validate()"/>
    </div>
    <div class="notabene">
      Tes données sont protégées et supprimables sur demande à
      <a href="mailto:estelle.monceyron@oztamu.fr" target="_blank">estelle.monceyron@oztamu.fr</a>. Ce site est protégé par reCAPTCHA : <a
      href="https://policies.google.com/privacy" target="_blank">Confidentialité</a> et
      <a href="https://policies.google.com/terms" target="_blank">Conditions de Google.</a>
    </div>
  </div>
</div>
